import React from 'react'
import styled from 'styled-components'
import { mixinInputForm } from 'spa/client/styles/mixin'
import { useFormContext } from 'react-hook-form'

export type Props = {
  name: string,
  defaultValue: string,
  options: string[],
} & React.SelectHTMLAttributes<HTMLSelectElement>

const StyledSelectBoxContainer = styled.div`
  position: relative;

  &::after {
    content: "";
    position: absolute;
    right: 12px;
    top: 24px;
    width: 8px;
    height: 8px;
    border-top: 2px solid ${props => props.theme.members.colors.silver._70};
    border-left: 2px solid ${props => props.theme.members.colors.silver._70};
    transform: translateY(-75%) rotate(-135deg);
    font-size: 20px;
    pointer-events: none;
  }
`

const StyledSelect = styled.select`
  ${mixinInputForm}
  appearance: none;
`

export const StyledSelectForm: React.FC<Props> = (props: Props) => {
  const { register } = useFormContext()

  // TODO react-hook-formを使ったバリデーションエラーメッセージ表示の実装をしたい
  return (
    <StyledSelectBoxContainer>
      <StyledSelect defaultValue={props.defaultValue || ""} required={props.required} disabled={props.disabled} {...register(props.name, { required: { value: props.required } })} >
        <option value="" disabled>{props.placeholder || '選択してください'}</option>
        {props.options.map((option: string, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
      </StyledSelect>
    </StyledSelectBoxContainer>
  )
}
